import type { SxProps, Theme } from '@mui/material/styles';

export const actionButtonSx: SxProps<Theme> = {
  minWidth: 182,
  textTransform: 'none',
  padding: '.545rem 2rem',
  borderRadius: '.5rem',
};

export const actionButtonSmallSx: SxProps<Theme> = {
  minWidth: 150,
  textTransform: 'none',
  padding: '4px 10px',
  borderRadius: '.5rem',
};

export const containerTitleSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  paddingBottom: '2rem',
  borderBottom: '1px solid #D7D9E0',
  alignItems: 'center',
};

export const modalStyles = {
  containerTitleSx,
  actionButtonSx,
  actionButtonSmallSx,
};
